import { QuestionTypeEnum } from '@/models/Question';
import { QuestionViewPropsFor } from '@/components/question/view/types';

export function useWritingCorrection(
  props: QuestionViewPropsFor<QuestionTypeEnum.WRITING>,
) {
  const answer = props.value ?? '';
  const hasAnswer = answer.trim().length > 0;

  return { answer, hasAnswer };
}
